module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAIAAADgcHrrAAABX0lEQVQokWP4X1n5////r1//y8nNYGBohaBly179l5ICIiADLghUcKprw3cLiz9r1zJ8XHLxv4vL/+vXgZqLio4wMNQB0bx59/5LSgIRkAERyU/Z+j+37H9MzP+fPzdsuMDAwNBTmnXgSULGx/Dw/3/+HDr0VFKyvrv78FMxMSACMoDcLdVzX5uZ/d+0CWh0TMw8BoZYBrAD6tDkrl79ANF2+cQTNBPBekIZgIr+f//+/+ZNNPREUBCIMMUfbt9+Ztkyhv8MDP8YGB4QjfYwMKwGOpFcbeQ5Eh4kQB8D/Q30PTAMgCEBCRJg2IDM3bQJGFrAMEMECQNDbXb2DjQ5tAhANtHbpZqBwZfh9OkPwBi84+9/IDA8yKsNbFhsaemSg0JCQARkQERCQibeufPoRGfnUjW1Ap9EBmBKuWZoOC2tWVg4EWw7CGVlTV0vKAhEQAZcEKigvX3+qrlzm/X1Ab+qR4DAw2xtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag/en.png
// module id = 6qMH
// module chunks = 1